import { QueryParamsHandling } from '@angular/router';

import { MenuItem, TooltipOptions } from 'primeng/api';

import { IMenuItem } from './i-menu-item';
import { ISummitItemEvent } from './i-summit-item-event';
import { SummitIdObject } from './summit-id-object';

export class SummitMenuItem<T extends SummitIdObject> implements IMenuItem<T> {
  //adding callbacks
  disabledCallback?: (element: T) => boolean;
  visibleCallback?: (element: T) => boolean;
  itemsCallback?: (element: T) => MenuItem[];

  //MenuItem properties
  label?: string;
  icon?: string;
  command?: (event?: ISummitItemEvent<T>) => void;
  url?: string;
  items?: IMenuItem<T>[];
  expanded?: boolean;
  disabled?: boolean;
  visible?: boolean;
  target?: string;
  escape?: boolean;
  routerLinkActiveOptions?: any;
  separator?: boolean;
  badge?: string;
  tooltip?: string;
  tooltipPosition?: string;
  badgeStyleClass?: string;
  style?: any;
  styleClass?: string;
  title?: string;
  id?: string;
  automationId?: any;
  tabindex?: string;
  routerLink?: any;
  queryParams?: {
    [k: string]: any;
  };
  fragment?: string;
  queryParamsHandling?: QueryParamsHandling;
  preserveFragment?: boolean;
  skipLocationChange?: boolean;
  replaceUrl?: boolean;
  iconStyle?: any;
  iconClass?: string;
  state?: {
    [k: string]: any;
  };
  tooltipOptions?: TooltipOptions;
  flags?: string[];

  //Static Functions
  static applyCallBacks<T extends SummitIdObject>(item: IMenuItem<T>, element: T, disableAll: boolean): IMenuItem<T> {
    if (disableAll) item.disabled = true;
    else if (item.disabled === undefined && item.disabledCallback) item.disabled = item.disabledCallback(element);

    if (item.visible === undefined && item.visibleCallback) item.visible = item.visibleCallback(element);
    if (item.items === undefined && item.itemsCallback) item.items = item.itemsCallback(element);

    return item;
  }

  static setElement<T extends SummitIdObject>(items: IMenuItem<T>[], element: T, disableAll: boolean): IMenuItem<T>[] {
    //console.log(`SummitMenuItem.setElement`, items);
    if (!items || items.length == 0) return items;
    const lclMenu = items.map((item) => Object.assign({}, item));
    lclMenu.map((item) => {
      const oldCommand = item.command;
      if (oldCommand) {
        item.command = ($event) => {
          //Inject properties into event
          if ($event) $event.element = element;
          oldCommand($event);
        };
      }
      if (item.items) item.items = SummitMenuItem.setElement(item.items, element, disableAll);
      SummitMenuItem.applyCallBacks(item, element, disableAll); //done after sub-items for disabling/visibility of parent menu
      //after applying call back to simplify logic
      if (item.items) item.disabled = item.disabled || item.items.filter((x) => x.disabled).length == item.items.length;
      if (item.items) item.visible = item.visible && item.items.some((x) => x.visible || x.visible === undefined);
    });
    return lclMenu;
  }
}
